var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5C6.5 10.0837 9.41633 13 13 13C16.5837 13 19.5 10.0837 19.5 6.5C19.5 2.91633 16.5837 0 13 0C9.41633 0 6.5 2.91633 6.5 6.5ZM24.5556 27.4444H26V26C26 20.4259 21.463 15.8889 15.8889 15.8889H10.1111C4.53556 15.8889 0 20.4259 0 26V27.4444H24.5556Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ad9bfa3b5290c8c938fb4083385f58cb.svg";
export { ForwardRef as ReactComponent };